var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.show),expression:"$route.meta.show"}]}),_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.show),expression:"$route.meta.show"}],staticClass:"bottom-safe-area"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }